function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createConfig, http } from 'wagmi';
import { bsc, mainnet, polygon } from 'wagmi/chains';
import { walletConnect } from 'wagmi/connectors';
import { WC_PROJECT_ID } from './constants';
export var config = function () {
  if (!WC_PROJECT_ID) throw new Error('WALLET_CONNECT_PROJECT_ID is not set');
  return createConfig({
    chains: [polygon, mainnet, bsc],
    connectors: [walletConnect({
      metadata: {
        description: 'Link wallet with foodriver telegram mini app',
        icons: ["".concat(globalThis.location.origin, "/favicon/favicon.ico")],
        name: 'FooDriver TMA',
        url: globalThis.location.origin
      },
      projectId: WC_PROJECT_ID
    })],
    ssr: false,
    transports: _defineProperty(_defineProperty(_defineProperty({}, polygon.id, http(polygon.rpcUrls.default.http[0])), mainnet.id, http('https://bsc-mainnet.infura.io/v3/adb27fcc69d3421f963d64e05439b327')), bsc.id, http(bsc.rpcUrls.default.http[0]))
  });
}();